export default {
    topics: [
        {
            title: ' describeWSDL ',
            href: 'sm-workflow-describeWSDL.html',
            attributes: { 'data-id': 'sm-workflow-describeWSDL' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-describeWSDL-d66e4273',
            topics: [],
        },
        {
            title: ' generateSOAPCode ',
            href: 'sm-workflow-generateSOAPCode.html',
            attributes: { 'data-id': 'sm-workflow-generateSOAPCode' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-generateSOAPCode-d66e4281',
            topics: [],
        },
        {
            title: ' readSurveySchema ',
            href: 'sm-workflow-readSurveySchema.html',
            attributes: { 'data-id': 'sm-workflow-readSurveySchema' },
            menu: { hasChildren: false },
            tocID: 'sm-workflow-readSurveySchema-d66e4289',
            topics: [],
        },
    ],
};

